import type { Ticket } from "../../types";
import "./TicketPill.scss";

interface TicketPillProps {
  ticket: Ticket;
  selectable?: boolean;
  selected?: boolean;
  onSelect?: (ticket: Ticket) => void;
}

export const TicketPill = ({
  ticket,
  selectable = false,
  selected = false,
  onSelect,
}: TicketPillProps) => {
  const handleClick = () => {
    if (selectable && onSelect) {
      onSelect(ticket);
    }
  };

  return (
    <div
      className={`ticket-pill ${selectable ? "selectable" : ""} ${selected ? "selected" : ""}`}
      onClick={handleClick}
    >
      <span className="ticket-id">{ticket.identifier}</span>
      {ticket.isSold && ticket.soldDate && (
        <div className="sold-info">
          <span className="sold-date">
            {ticket.soldDate?.toDate().toLocaleDateString()}
          </span>
          <span className="sold-by">{ticket.soldBy}</span>
        </div>
      )}
    </div>
  );
};
